import { useLingui } from "@lingui/react/macro";
import { ParkingOption } from "@offstreetparking/design-system/dataDisplay/ParkingOption";
import { Heading } from "@offstreetparking/design-system/typography";
import { Text } from "@offstreetparking/design-system/typography";
import { ParkingLocations } from "../../parkingDetails/ParkingLocations";
import { ParkingVenue } from "../../parkingDetails/ParkingVenue";
import type { Permit } from "../types";
export type ParkingDetailsSectionProps = {
	title: Permit["title"];
	parkingOptionTitle?: Permit["parkingOptionTitle"];
	permitIntervals: {
		startDateTimeISO: string;
		endDateTimeISO?: string | null;
	}[];
	timezone: Permit["timezone"];
	locations: {
		lot?: {
			centerLat?: string;
			centerLng?: string;
			addressLineOne?: string;
			addressLineTwo?: string;
			city?: string;
			state?: string;
			country?: string;
			postalCode?: string;
			useAddress?: boolean;
			name: string;
		};
		name: string;
		order: number;
	}[];
	venue?: Permit["venue"];
};
export const ParkingDetailsSection = ({
	title,
	parkingOptionTitle,
	permitIntervals,
	timezone,
	locations,
	venue,
}: ParkingDetailsSectionProps) => {
	const { t } = useLingui();
	const cardTitle = parkingOptionTitle?.trim() || title;
	return (
		<>
			{venue && <ParkingVenue venue={venue} />}
			<Heading As="h2" kind="h3">
				{t`Parking Details`}
			</Heading>
			<div className="overflow-hidden rounded-lg border-1 border-neutral-faded bg-white [print-color-adjust:exact]">
				<div className="bg-neutral-faded px-3 py-2 [print-color-adjust:exact]">
					<Text size="md" weight="bold">
						{cardTitle}
					</Text>
				</div>
				<div className="px-4 pt-4">
					<ParkingOption timezone={timezone} permitIntervals={permitIntervals} isInstant={false} />
				</div>
				<ParkingLocations locations={locations} />
			</div>
		</>
	);
};
